if (!customElements.get("s-cookie-banner")) {
  customElements.define(
    "s-cookie-banner",
    class SectionCookieBanner extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.bannerAppearingDelay = Number(this.dataset.delay);

        this.cookieBanner = this.querySelector(".js-cookie-banner__sticky-banner");
        this.preferencesTab = this.querySelector(".js-cookie-banner__preferences");
        this.overlay = this.querySelector(".js-cookie-banner__overlay");

        this.acceptAllButtons = this.querySelectorAll(".js-accept-all");
        this.declineAll = this.querySelector(".js-decline-all");
        this.choosePreferencesButton = this.querySelector(".js-choose-preferences");
        this.savePreferencesButton = this.querySelector(".js-save-choices");

        this.loadCustomerPrivacyAPI((error) => {
          if (error) {
            console.error("Failed to load the consent tracking API:", error);
            return;
          }

          const consentStatus = window.Shopify.customerPrivacy.currentVisitorConsent();

          if ((consentStatus.marketing === "" || consentStatus.analytics === "" || consentStatus.preferences === "")) {
            setTimeout(() => {
              this.showConsentBanner();
            }, this.bannerAppearingDelay);
          }
        });

        this.acceptAllButtons.forEach((button) => {
          button.addEventListener("click", this.acceptAllCookie);
        });
        this.declineAll.addEventListener("click", this.declineAllCookie);

        this.choosePreferencesButton.addEventListener("click", this.openPreferencesTab);
        this.savePreferencesButton.addEventListener("click", this.setCustomTrackingConsent);
      }

      disconnectedCallback() {
        this.acceptAllButtons.forEach((button) => {
          button.removeEventListener("click", this.acceptAllCookie);
        });
        this.declineAll.removeEventListener("click", this.declineAllCookie);

        this.choosePreferencesButton.removeEventListener("click", this.openPreferencesTab);
        this.savePreferencesButton.removeEventListener("click", this.setCustomTrackingConsent);
      }

      loadCustomerPrivacyAPI = (callback) => {
        window.Shopify.loadFeatures(
          [
            {
              name: "consent-tracking-api",
              version: "0.1",
            },
          ],
          callback
        );
      };

      showConsentBanner = () => {
        this.overlay.classList.add("is-active");
        this.cookieBanner.classList.add("is-active");
        document.body.classList.add("cookie-banner-is-active");
      };

      hideConsentBanner = () => {
        this.cookieBanner.classList.remove("is-active");
        this.overlay.classList.remove("is-active");
        document.body.classList.remove("cookie-banner-is-active");
      };

      acceptAllCookie = () => {
        window.Shopify.customerPrivacy.setTrackingConsent(true, this.handleCloseModals);
      };

      declineAllCookie = () => {
        window.Shopify.customerPrivacy.setTrackingConsent(false, this.handleCloseModals);
      };

      setCustomTrackingConsent = () => {
        const analyticsConsent = this.querySelector("#analytics-cookie").checked;
        const marketingConsent = this.querySelector("#marketing-cookie").checked;
        const personalizationConsent = this.querySelector("#personalization-cookie").checked;

        let cookie = {};
        cookie.analytics = analyticsConsent;
        cookie.marketing = marketingConsent;
        cookie.preferences = personalizationConsent;

        window.Shopify.customerPrivacy.setTrackingConsent(cookie, this.handleCloseModals);
      };

      openCountryDetected = () => {
        window.PubSub.publish("open-country-detected");
      };

      openPreferencesTab = () => {
        this.cookieBanner.classList.remove("is-active");
        this.preferencesTab.classList.add("is-active");
      };

      closePreferencesTab = () => {
        this.preferencesTab.classList.remove("is-active");
      };

      handleCloseModals = () => {
        if (this.cookieBanner.classList.contains("is-active")) this.hideConsentBanner();
        if (this.preferencesTab.classList.contains("is-active")) this.closePreferencesTab();

        this.overlay.classList.remove("is-active");
        document.body.classList.remove("cookie-banner-is-active");

        this.openCountryDetected();
      };
    }
  );
}
